import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import MiniMessenger from './MiniMessenger/MiniMessenger.vue';
import { AllChats } from '@/components/ProfileComponents';
import { useChatStore } from '@/store/modules/chat';
import { computed, Ref, ref } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { FormDataType, MiniMessengerType } from '@/types/MessangerTypes';
import { MessagesFromChanelType } from '@/api/chat/types';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Messenger',
  props: {
    isMini: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const isShowAllMessagesLoading = ref(false);
const isLoadingChatByHouseId = ref(false);
const sendMessageChatsLoading: Ref<(number | 'newChat')[]> = ref([]);
const loadingChatIds: Ref<(number | 'newChat')[]> = ref([]);
const currentChannelId: Ref<number | undefined | null | 'newChat'> = ref(undefined);
const miniMessengerInfo: Ref<MiniMessengerType | undefined> = ref(undefined);
const router = useRouter();
const formData: Ref<FormDataType> = ref({
  messages: {},
});

const allMessages = computed((): MessagesFromChanelType[] => {
  return useChatStore().allChats;
});
const chatInfo = computed((): { [key: string]: MessagesFromChanelType } => {
  return useChatStore().chatInfo;
});
const showAllChats = async () => {
  isShowAllMessagesLoading.value = true;
  try {
    await useChatStore().getAllChannels();
  } finally {
    isShowAllMessagesLoading.value = false;
  }
};

const getMessagesByChannelId = async (channelId: number) => {
  loadingChatIds.value.push(channelId);
  try {
    await useChatStore().getChannelById(channelId);
  } catch {
    useChatStore().deleteOpenChatId(channelId);
  } finally {
    currentChannelId.value = channelId;
    const index = loadingChatIds.value.findIndex(el => el === channelId);

    if (index >= 0) {
      loadingChatIds.value.splice(index, 1);
    }
  }
};
const getMessagesByLandId = async (houseId: number) => {
  isLoadingChatByHouseId.value = true;

  try {
    currentChannelId.value = await useChatStore().findChannelByLandId(houseId);

    if (currentChannelId.value) {
      await getMessagesByChannelId(currentChannelId.value);
    } else {
      currentChannelId.value = 'newChat';
      miniMessengerInfo.value = useChatStore().miniMessenger;
    }
  } catch (error) {
    if (props.isMini) {
      useChatStore().closeMiniMessenger();
      useAppStore().openAlert('', error as string);
    }
  } finally {
    isLoadingChatByHouseId.value = false;
  }
};

const sendMessage = async (chatId: number | undefined | null | 'newChat') => {
  if (chatId && chatId !== 'newChat') {
    sendMessageChatsLoading.value.push(chatId);
    try {
      const res = await useChatStore().sendMessageInChannel(
        formData.value.messages[chatId],
        chatId,
      );

      if (res) {
        delete formData.value.messages[chatId];
      }
    } finally {
      const index = sendMessageChatsLoading.value.findIndex(el => el === chatId);

      if (index >= 0) {
        sendMessageChatsLoading.value.splice(index, 1);
      }
    }
  } else if (miniMessengerInfo.value && chatId && miniMessengerInfo.value.landId) {
    sendMessageChatsLoading.value.push(chatId);
    try {
      const res = await useChatStore().sendMessageByLand(
        formData.value.messages[chatId],
        miniMessengerInfo.value,
      );

      if (res) {
        currentChannelId.value = res.channelId;
        delete formData.value.messages[chatId];
      }
    } finally {
      const index = sendMessageChatsLoading.value.findIndex(el => el === chatId);

      if (index >= 0) {
        sendMessageChatsLoading.value.splice(index, 1);
      }
    }
  }
};

const deleteChatById = (chatId: number) => {
  if (currentChannelId.value === chatId) {
    currentChannelId.value = null;
    router.replace({ query: undefined });
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.isMini)
    ? (_openBlock(), _createBlock(MiniMessenger, {
        key: 0,
        modelValue: formData.value.messages[currentChannelId.value],
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.messages[currentChannelId.value]) = $event)),
        allMessages: allMessages.value,
        chatInfo: chatInfo.value[currentChannelId.value],
        isLoadingChatByHouseId: 
      isLoadingChatByHouseId.value ||
      !!(currentChannelId.value && loadingChatIds.value.includes(currentChannelId.value))
    ,
        isSendMessageLoading: 
      !!(currentChannelId.value && sendMessageChatsLoading.value.includes(currentChannelId.value))
    ,
        isShowAllMessagesLoading: isShowAllMessagesLoading.value,
        "mini-messenger-info": miniMessengerInfo.value,
        onGetMessagesByChannelId: getMessagesByChannelId,
        onGetMessagesByLandId: getMessagesByLandId,
        onSendMessage: _cache[1] || (_cache[1] = ($event: any) => (sendMessage(currentChannelId.value))),
        onShowAllChats: showAllChats
      }, null, 8, ["modelValue", "allMessages", "chatInfo", "isLoadingChatByHouseId", "isSendMessageLoading", "isShowAllMessagesLoading", "mini-messenger-info"]))
    : (_openBlock(), _createBlock(_unref(AllChats), {
        key: 1,
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData).value = $event)),
        allMessages: allMessages.value,
        chatInfo: chatInfo.value,
        isShowAllMessagesLoading: isShowAllMessagesLoading.value,
        loadingChatIds: loadingChatIds.value,
        sendMessageChatsLoading: sendMessageChatsLoading.value,
        onDeleteChatById: deleteChatById,
        onGetMessagesByChannelId: getMessagesByChannelId,
        onSendMessage: sendMessage,
        onShowAllChats: showAllChats
      }, null, 8, ["modelValue", "allMessages", "chatInfo", "isShowAllMessagesLoading", "loadingChatIds", "sendMessageChatsLoading"]))
}
}

})